import React from "react";
import Typography from "@mui/material/Typography";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Link } from "react-router-dom";
import { formatEmpty } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function UserNameCell(cell) {
  const userId = nullCheck(cell, "", "row", "original", "userId");
  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <AccountCircleIcon sx={{ fontSize: "22px", color: "black_solid.80", marginRight: "5px" }} />
      <Link
        to={`/dashboard/admin/user-management/user-profile?user-id=${userId}`}
        style={{ textDecoration: "none" }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "black_solid.80",
            "&:hover": {
              color: "primary.60",
              cursor: "pointer"
            }
          }}
        >
          {formatEmpty(cell.value)}
        </Typography>
      </Link>
    </span>
  );
}